import { render, staticRenderFns } from "./jcjg.vue?vue&type=template&id=90825e32&scoped=true&"
import script from "./jcjg.vue?vue&type=script&lang=js&"
export * from "./jcjg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90825e32",
  null
  
)

export default component.exports